import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as fileActions from '../../actions/fileActions';

const ImageUpload = ({
  contentKey,
  inputId,
  onUploadComplete,
  uploadImage,
  aspectRatio = 1,
  minWidth = 1200,
  minHeight = 1200,
  isUploadInProgress,
  renderButton,
}) => {
  const handleUpload = e => {
    const file = e.target;
    if (file && file.files.length > 0) {
      uploadImage(file, contentKey, onUploadComplete, aspectRatio, minWidth, minHeight);
    }
  };

  return (
    <div className="file-input-button-container">
      <label htmlFor={inputId} className="file-input-button" style={{ marginBottom: 0 }}>
        {renderButton(isUploadInProgress)}
      </label>
      <input
        type="file"
        id={inputId}
        onChange={handleUpload}
        onClick={e => {
          e.target.value = null;
        }}
        disabled={isUploadInProgress}
        accept="image/*"
      />
    </div>
  );
};

ImageUpload.propTypes = {
  contentKey: PropTypes.string.isRequired,
  inputId: PropTypes.string.isRequired,
  onUploadComplete: PropTypes.func.isRequired,
  renderButton: PropTypes.func.isRequired,
  minWidth: PropTypes.number,
  minHeight: PropTypes.number,
  aspectRatio: PropTypes.number,
  isUploadInProgress: PropTypes.bool,
  uploadImage: PropTypes.func,
};

const mapStateToProps = (state, ownProps) => {
  const currentUpload = state.cards.file.filePreview[ownProps.contentKey];
  return {
    isUploadInProgress: !!currentUpload && currentUpload.busy,
  };
};

const mapDispatchToProps = dispatch => ({
  uploadImage: (...args) => dispatch(fileActions.uploadToZolaAndCrop(...args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ImageUpload);
